import React from "react";
import { cls } from "app/utils";
import { useTranslation } from "react-i18next";
import UserAvatar from "app/components/UserAvatar";
import { FamilyMember } from "../../types";
import styles from "./styles.module.scss";

interface Props {
  member: FamilyMember;
  onEdit: (member: FamilyMember) => void;
  onDelete: (member: FamilyMember) => void;
}

const FamilyMemberCard = ({ member, onEdit, onDelete }: Props) => {
  const { t } = useTranslation();
  const fullName = `${member.firstName} ${member.lastName}`.trim();

  return (
    <div className={styles.card}>
      <UserAvatar
        sizeWidth={48}
        sizeHeight={48}
        altName={fullName}
        srcName={member.avatar ?? "default"}
        userName={fullName}
        className={cls("avatar", styles.avatar)}
      />

      <div className={styles.info}>
        <span className={styles.name}>{fullName}</span>
        <span className={styles.meta}>{t("Age {{age}}", { age: member.age })}</span>
      </div>

      <div className={styles.actions}>
        <button
          type="button"
          className={styles.icon_button}
          aria-label={t("Edit")}
          onClick={() => onEdit(member)}
        >
          <i className="ico ico-pencil-o" />
        </button>
        <button
          type="button"
          className={styles.icon_button}
          aria-label={t("Remove")}
          onClick={() => onDelete(member)}
        >
          <i className="ico ico-trash-outline" />
        </button>
      </div>
    </div>
  );
};

export default FamilyMemberCard;
